import React, { useState } from 'react'

import Dialog from '@react/react-spectrum/Dialog'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield/js/Textfield'
import Tooltip from '../Tooltip'

import './RenameScreen.scss'

export default function RenameScreenDialog({ screen, screens, onRename, ...otherProps }) {
  const [titleInput, setTitleInput] = useState({ value: screen.meta.title })
  const [nameInput, setNameInput] = useState({ value: screen.meta.name, invalid: false })

  const onNameChange = (value) => {
    const isValidName = /^[a-z][a-zA-Z0-9-_$]+$/i.test(value)
    const isUniqueName = !screens.find((s) => s.meta.name !== screen.meta.name && s.meta.name === value)
    if (isValidName && isUniqueName) {
      setNameInput({ value, invalid: false })
    } else {
      setNameInput({ value, invalid: true })
    }
  }

  return (
    <Dialog
      {...otherProps}
      title='Rename screen'
      confirmLabel='OK'
      cancelLabel='Cancel'
      confirmDisabled={nameInput.invalid}
      onConfirm={() => {
        onRename({ newTitle: titleInput.value, newName: nameInput.value })
      }}
      role='dialog'
    >
      <FieldLabel label='Title' labelFor='screen-settings-title'>
        <Textfield
          placeholder={'Title'}
          id='screen-settings-title'
          value={titleInput.value}
          onChange={(value) => setTitleInput({ value })}
          invalid={titleInput.invalid}
        />
      </FieldLabel>

      <div className='RenameScreen__FieldLabel--name'>
        <FieldLabel label='Name' labelFor='screen-settings-name'>
          <Tooltip content={NAME_TOOLTIP} className='RenameScreen__Tooltip' />
          <Textfield
            placeholder={'Unique name'}
            id='screen-settings-name'
            value={nameInput.value}
            onChange={onNameChange}
            invalid={nameInput.invalid}
          />
        </FieldLabel>
      </div>
    </Dialog>
  )
}

const NAME_TOOLTIP =
  'Changing the screen name may result in respective updates to other elements of the project, such as navigation. After you are done here, before proceeding to other tabs we recommend reloading the page.'
